// @flow
import * as React from 'react';

import AdminNoticeBanner from 'admin/components/AdminNoticeBanner';
import Button from 'components/Button';
import Container from 'components/Container';
import Heading from 'components/Heading';
import List from 'components/List';
import ListItem from 'components/ListItem';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';

import type { AdminNewAutoMessageOrgs_organizations } from './queries/__generated__/AdminNewAutoMessageOrgs';
import type { AutoMessageTabKey } from './';

type Props = {
  formatCSVComplete: boolean,
  syncDataComplete: boolean,
  composeComplete: boolean,
  selectedOrg: AdminNewAutoMessageOrgs_organizations,
  onJump: (key: AutoMessageTabKey) => void,
};

function ErrorFormat(props: {
  title: string,
  details: string[],
  tabKey: AutoMessageTabKey,
  onClickCompleteButton: (key: AutoMessageTabKey) => void,
}) {
  return (
    <MediaObject figure="right">
      <div>
        <Heading level="6">{props.title}</Heading>
        <List marker="number" size="medium">
          {props.details.map(detail => (
            <ListItem key={detail}>{detail}</ListItem>
          ))}
        </List>
      </div>
      <Button
        size="xxsmall"
        color="lava"
        level="secondary"
        onClick={() => props.onClickCompleteButton(props.tabKey)}>
        Complete
      </Button>
    </MediaObject>
  );
}

export default function AdminNewAutoMessageReviewIncompleteItems(props: Props) {
  const { selectedOrg, formatCSVComplete, syncDataComplete, composeComplete, onJump } = props;

  if (formatCSVComplete && syncDataComplete && composeComplete) {
    return null;
  }

  const formatCSVError = (
    <ErrorFormat
      title="Export CSV Report"
      details={['Enter a CSV filename']}
      tabKey="format-csv"
      onClickCompleteButton={onJump}
    />
  );
  const syncDataError = (
    <ErrorFormat
      title="Transfer Files to Remind"
      details={['Select a set of SFTP credentials']}
      tabKey="sync-data"
      onClickCompleteButton={onJump}
    />
  );
  const composeMessageErrorDetails = ['Select recipients', 'Type your message'];
  // we only need this error detail for schools; users
  // don't need to manually select a sender for a district
  if (selectedOrg.type === 'School') {
    composeMessageErrorDetails.unshift('Assign an individual administrator as sender');
  }
  const composeMessageError = (
    <ErrorFormat
      title="Compose"
      details={composeMessageErrorDetails}
      tabKey="compose"
      onClickCompleteButton={onJump}
    />
  );

  return (
    <Row>
      <Container size="medium" flush align="left">
        <AdminNoticeBanner
          alwaysShowDetails
          icon="explanation-circle"
          color="lava"
          actionElement={null}
          details={
            <List size="large">
              {!formatCSVComplete && formatCSVError}
              {!syncDataComplete && syncDataError}
              {!composeComplete && composeMessageError}
            </List>
          }>
          Please complete the following before setting your auto message live.
        </AdminNoticeBanner>
      </Container>
    </Row>
  );
}
